import React , {useRef , useState , useEffect }from 'react'; 
import { Menubar } from 'primereact/menubar';
import { Toast } from 'primereact/toast';
//import {  useLocation } from "react-router-dom";




//var state = useLocation.state

export default function MenuLawyer( { state , changeState }) {
    const toast = useRef(null);
    const [theState,setTheState] = useState( state )


    useEffect(() => {

        setTheState( state )

    } , [state])



    const items = [
        

        {
            label: 'Horarios Abogado',
            icon: 'pi pi-graduation-cap',
            command: () => { changeState( 1 ) ;
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Consulta un Abogago', life: 3000 });
            }
        },
        {
            label: 'Consulta Express',
            icon: 'pi pi-eye',
            command: () => { changeState( 2 ) ;
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Consulta Express', life: 3000 });
            }
        },
        {
            label: 'Estadisticas de citas',
            icon: 'pi pi-wallet',
            command: () => { changeState( 3 ) ;
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Citas Abogado', life: 3000 });
            }
        },
        {
            label: 'Actualizar datos Personales',
            icon: 'pi pi-pen-to-square',
            command: () => 
                { toast.current.show({ severity: 'success', summary: 'Success', detail: 'Actualiza Datos', life: 3000 });
            }
        },

    ];

    return (
        <div className="card">
            <Menubar model={items} />
            <Toast ref={toast} />
        </div>
    )
}
         